
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as AiIconComponent } from "./ai-icon.svg";

export const AiIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <AiIconComponent {...props} />;
};
